import React from 'react';

const ERALogo = ({ className = '', variant = 'full' }) => {
  if (variant === 'icon') {
    // Icon version for smaller spaces
    return (
      <div className={`inline-flex items-center justify-center ${className}`}>
        <svg width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
          <rect width="48" height="48" rx="8" fill="#003d7a"/>
          <text x="24" y="30" fontFamily="Arial, sans-serif" fontSize="18" fontWeight="bold" textAnchor="middle" fill="white">ERA</text>
        </svg>
      </div>
    );
  }

  // Full logo version
  return (
    <div className={`inline-flex items-center ${className}`}>
      <svg width="200" height="60" viewBox="0 0 200 60" xmlns="http://www.w3.org/2000/svg">
        {/* Background shape */}
        <rect width="200" height="60" rx="8" fill="#003d7a"/>
        
        {/* ERA text */}
        <text x="50" y="38" fontFamily="Arial, sans-serif" fontSize="28" fontWeight="bold" fill="white">ERA</text>
        
        {/* Divider line */}
        <line x1="100" y1="15" x2="100" y2="45" stroke="white" strokeWidth="2" opacity="0.5"/>
        
        {/* GROUP text */}
        <text x="120" y="28" fontFamily="Arial, sans-serif" fontSize="14" fontWeight="300" fill="white" letterSpacing="2">GROUP</text>
        
        {/* USC text */}
        <text x="120" y="44" fontFamily="Arial, sans-serif" fontSize="12" fontWeight="bold" fill="#4a90e2">USC</text>
      </svg>
    </div>
  );
};

export default ERALogo;